import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'
import { PickersActionBar } from '@mui/x-date-pickers-pro'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField'
import JSONPretty from 'react-json-pretty';
import CustomActionBar from './CustomActionBar'

export const DateRangeFilter = ({ applyValue, item, value }) => {
    const [range, setRange] = useState();

    const { t } = useTranslation()

    useEffect(() => {
        setRange([value?.from ? dayjs(value.from) : null, value?.to ? dayjs(value.to) : null]);
    }, [value]);


    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateRangePicker
                closeOnSelect={false}
                format="DD/MM/YYYY"
                label={t('Select Filter')}
                onAccept={(values) => {
                    const from = values[0] ? values[0].format('YYYY-MM-DD') : null
                    const to = values[1] ? values[1].format('YYYY-MM-DD') : null
                    if (!from && !to) {
                        applyValue({ ...item, value: { from: null, to: null } })
                        setRange(values)
                    } else {
                        const value = { from, to }
                        if (from && to) {
                            applyValue({ ...item, value })
                            setRange(values)
                        } else {
                            setRange([null, null])
                        }
                    }

                }}
                slotProps={{
                    textField: {
                        placeholder: '',
                        variant: 'filled',
                        sx: {
                            width: 'inherit'
                        },
                    },
                    actionBar: {
                        actions: [
                            'accept',
                            'cancel',
                            'clear'
                        ],
                        applyValue,
                        item,
                        setRange
                    },
                    layout: {
                        className: 'mtska-date-picker-selector'
                    }
                }}
                slots={{
                    field: SingleInputDateRangeField,
                    actionBar: CustomActionBar,
                }}
                value={range}
                className="form-element filter-element form-element-date-picker"
            />
        </LocalizationProvider>
    )
}
